module.exports = __webpack_public_path__ + "static/media/1.0e9947d8.png";